import { VARIANTS } from '@jobcase/react_pattern_library/components/Notification';

import { setNotification } from '../../notification/actions';

import HiringEventAPI from '../../../../utils/api/hiringEventAPI';

export const TYPES = {
  GET_REGISTRANT_RESUME_REQUEST: 'hiringEventsRegistrants/GET_REGISTRANT_RESUME_REQUEST',
  GET_REGISTRANT_RESUME_SUCCESS: 'hiringEventsRegistrants/GET_REGISTRANT_RESUME_SUCCESS',
  GET_REGISTRANT_RESUME_ERROR: 'hiringEventsRegistrants/GET_REGISTRANT_RESUME_ERROR',
  GET_REGISTRANT_DETAILS_REQUEST: 'hiringEventsRegistrants/GET_REGISTRANT_DETAILS_REQUEST',
  GET_REGISTRANT_DETAILS_SUCCESS: 'hiringEventsRegistrants/GET_REGISTRANT_DETAILS_SUCCESS',
  GET_REGISTRANT_DETAILS_ERROR: 'hiringEventsRegistrants/GET_REGISTRANT_DETAILS_ERROR',
  GET_REGISTRANTS_REQUEST: 'hiringEventsRegistrants/GET_REGISTRANTS_REQUEST',
  GET_REGISTRANTS_SUCCESS: 'hiringEventsRegistrants/GET_REGISTRANTS_SUCCESS',
  GET_REGISTRANTS_ERROR: 'hiringEventsRegistrants/GET_REGISTRANTS_ERROR',
  GET_MORE_REGISTRANTS_REQUEST: 'hiringEventsRegistrants/GET_MORE_REGISTRANTS_REQUEST',
  GET_MORE_REGISTRANTS_SUCCESS: 'hiringEventsRegistrants/GET_MORE_REGISTRANTS_SUCCESS',
  GET_MORE_REGISTRANTS_ERROR: 'hiringEventsRegistrants/GET_MORE_REGISTRANTS_ERROR',
  CLEAR_REGISTRANTS_LIST_STATE: 'hiringEventsRegistrants/CLEAR_REGISTRANTS_LIST_STATE',
  CLEAR_CURRENT_REGISTRANT_STATE: 'hiringEventsRegistrants/CLEAR_CURRENT_REGISTRANT_STATE',
  CLEAR_CURRENT_REGISTRANT_RESUME_STATE: 'hiringEventsRegistrants/CLEAR_CURRENT_REGISTRANT_RESUME_STATE',
  UPDATE_ATTENDANCE_STATUS_REQUEST: 'hiringEventsRegistrants/UPDATE_ATTENDANCE_STATUS_REQUEST',
  UPDATE_ATTENDANCE_STATUS_SUCCESS: 'hiringEventsRegistrants/UPDATE_ATTENDANCE_STATUS_SUCCESS',
  UPDATE_ATTENDANCE_STATUS_FAILURE: 'hiringEventsRegistrants/UPDATE_ATTENDANCE_STATUS_FAILURE',
  CLEAR_STATE: 'hiringEventsRegistrants/CLEAR_STATE',
};

export const getEventRegistrantsData = (eventId, queryParams, requestBody) => async (dispatch) => {
  dispatch({ type: TYPES.GET_REGISTRANTS_REQUEST });
  try {
    const response = await HiringEventAPI().getEventRegistrantsData(eventId, queryParams, requestBody);
    const data = response?.data || {};
    dispatch({ type: TYPES.GET_REGISTRANTS_SUCCESS, payload: { eventId, data } });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_REGISTRANTS_ERROR, payload: error });
    if (error?.errors) {
      dispatch(setNotification(`An error occurred while loading the event registrants. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading the hiring event.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const getMoreEventRegistrantsData = (eventId, queryParams, requestBody) => async (dispatch) => {
  dispatch({ type: TYPES.GET_MORE_REGISTRANTS_REQUEST });
  try {
    const response = await HiringEventAPI().getEventRegistrantsData(eventId, queryParams, requestBody);
    const data = response?.data || {};
    dispatch({ type: TYPES.GET_MORE_REGISTRANTS_SUCCESS, payload: { eventId, data } });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_MORE_REGISTRANTS_ERROR, payload: error });
    if (error?.errors) {
      dispatch(setNotification(`An error occurred while loading the event registrants. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading the hiring event.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const getRegistrantResume = options => async (dispatch) => {
  dispatch({ type: TYPES.CLEAR_CURRENT_REGISTRANT_RESUME_STATE });
  dispatch({ type: TYPES.GET_REGISTRANT_RESUME_REQUEST });
  try {
    const response = await HiringEventAPI().getRegistrantResume(options?.registrantId, options?.resumeFilename, options?.resumeBlob);
    const blob = await response.blob();
    const contentType = response.headers.get('content-type') || 'application/pdf';
    const pdfContent = URL.createObjectURL(new Blob([blob], { type: contentType }));
    dispatch({ type: TYPES.GET_REGISTRANT_RESUME_SUCCESS, payload: { resume: pdfContent } });
    return pdfContent;
  } catch (error) {
    dispatch({ type: TYPES.GET_REGISTRANT_RESUME_ERROR, payload: error });
    if (error?.errors) {
      dispatch(setNotification(`An error occurred while loading registrant resume. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading the hiring event.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const getRegistrantDetails = options => async (dispatch) => {
  dispatch({ type: TYPES.GET_REGISTRANT_DETAILS_REQUEST });
  try {
    const response = await HiringEventAPI().getRegistrantDetails(options.registrantId);
    const data = response?.data || {};
    dispatch({ type: TYPES.GET_REGISTRANT_DETAILS_SUCCESS, payload: { currentRegistrant: data } });
    if (data?.resume_filename && data?.resume_blob_uri?.startsWith('resumes')) {
      dispatch(getRegistrantResume({
        registrantId: options.registrantId,
        resumeFilename: data?.resume_filename,
        resumeBlob: data?.resume_blob_uri,
      }));
    }
    return data;
  } catch (error) {
    dispatch({ type: TYPES.GET_REGISTRANT_DETAILS_ERROR, payload: error });
    if (error?.errors) {
      dispatch(setNotification(`An error occurred while loading registrant details. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading the hiring event.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const updateAttendanceStatus = options => async (dispatch) => {
  dispatch({ type: TYPES.UPDATE_ATTENDANCE_STATUS_REQUEST });
  try {
    await HiringEventAPI().patchAttendanceStatus(options.registrantId, options.attendedEvent);
    dispatch({ type: TYPES.UPDATE_ATTENDANCE_STATUS_SUCCESS }); // update payload
  } catch (error) {
    dispatch({ type: TYPES.UPDATE_ATTENDANCE_STATUS_FAILURE, payload: error });
    throw error;
  }
};

export const clearRegistrantsListState = () => ({ type: TYPES.CLEAR_REGISTRANTS_LIST_STATE });

export const clearCurrentRegistrantState = () => ({ type: TYPES.CLEAR_CURRENT_REGISTRANT_STATE });

export const clearCurrentRegistrantResumeState = () => ({ type: TYPES.CLEAR_CURRENT_REGISTRANT_RESUME_STATE });

export const clearState = () => ({ type: TYPES.CLEAR_STATE });

export default {
  getEventRegistrantsData,
  getMoreEventRegistrantsData,
  getRegistrantResume,
  getRegistrantDetails,
  clearRegistrantsListState,
  clearCurrentRegistrantState,
  clearCurrentRegistrantResumeState,
  updateAttendanceStatus,
  clearState,
};
